import React, { useState } from "react";
import "../../../index.css";
import "../../../App.css";
import Newsletter from "../../../helper/images/newsletter.png";
import { useTranslation } from "../../../hooks/useTranslation";
import { useMutation } from "@tanstack/react-query";
import { subscribeNewsletter } from "../../../api/common";
import toast from "react-hot-toast";
const SubscribeNewsletter = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");

  const { mutate: handleSubscribe, isPending } = useMutation({
    mutationFn: (payload) => subscribeNewsletter(payload),
    onSuccess: (response) => {
      // Response structure: { success: true, message: "...", data: { alreadySubscribed: true } }
      const alreadySubscribed = response?.data?.alreadySubscribed;
      if (alreadySubscribed) {
        toast.error(
          t("home").newsletter.alreadyMessage || "You are already subscribed."
        );
        return;
      }
      toast.success(
        response?.message || 
        t("home").newsletter.successMessage || 
        "You have subscribed successfully."
      );
      setEmail("");
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || 
                          error?.message ||
                          t("home").newsletter.errorMessage ||
                          "Failed to subscribe. Please try again.";
      toast.error(errorMessage);
      console.error("Newsletter subscription error:", error);
    },
  });

  const onSubmit = (event) => {
    event.preventDefault();
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      toast.error(
        t("home").newsletter.invalidEmail || "Please enter a valid email address."
      );
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmedEmail)) {
      toast.error(
        t("home").newsletter.invalidEmail || "Please enter a valid email address."
      );
      return;
    }

    handleSubscribe({ email: trimmedEmail });
  };

  return (
    <>
      <div className="container z-10 relative">
        <div
          className="lg:mt-[184px] lg:mb-[120px] md:mb[70px] mb-[30px] md:mt-[100px] mt-[30px] md:py-[64px] md:px-[50px] py-5 px-3 grid grid-cols-1 items-center lg:grid-cols-[auto_1fr] gap-5 lg:gap-[65px] max-w-[1280px] mx-auto rounded-[28px]"
          style={{
            backgroundImage: "url(" + Newsletter + ")",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="w-full lg:max-w-[372px]">
            <h2 className="md:text-[34px] text-[25px] text-white font-semibold mb-[11px] leading-[34px]">
              {t("home").newsletter.title}
            </h2>
            <p className="text-lg leading-6 text-white">
              {t("home").newsletter.description}
            </p>
          </div>
          <form
            className="w-full p-[2px] rounded-full border border-[#FFA808] flex  bg-[#FFF3EF] h-max"
            onSubmit={onSubmit}
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t("home").newsletter.placeholder}
              className="flex-1 rounded-full text-[#727272] bg-transparent outline-none  md:pl-[34px] pl-1"
            />
            <button
              type="submit"
              disabled={isPending}
              className="bg-[#4CAF50] hover:bg-[#FFA808] disabled:opacity-70 disabled:cursor-not-allowed text-white  md:px-[26px] md:py-3 px-3 py-2 rounded-full border border-white transition text-sm md:text-[20px] md:font-semibold font-medium leading-[30px]"
            >
              {isPending
                ? t("home").newsletter.buttonLoading || "Subscribing..."
                : t("home").newsletter.button}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default SubscribeNewsletter;
